import { GRID_CHECKBOX_SELECTION_COL_DEF } from "@mui/x-data-grid";
import { GridInitialStatePremium } from "@mui/x-data-grid-premium/models/gridStatePremium";

/** Must match `UnAssignedPassengersTable` column `field` order (see `columns` useMemo). */
const columnNames = [
    "index",
    "name",
    "companions",
    "route",
    "pickUp",
    "pickUpReason",
    "type",
    "userId",
    "notes",
    "actions",
];

export const defaultUnAssignedPassengersTableGridOptions: GridInitialStatePremium = {
    sorting: {
        sortModel: [{ field: "pickUp", sort: "asc" }],
    },
    pinnedColumns: {
        left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, "index", "name"],
        right: ["actions"],
    },
    columns: {
        orderedFields: columnNames,
        columnVisibilityModel: columnNames.reduce(
            (acc, field) => {
                acc[field] = true;
                return acc;
            },
            {} as Record<string, boolean>
        ),
    },
};
